import { useState } from 'react';
import { UserRoles } from '../shared/constants';

export interface DocumentWithPermission {
  id: string;
  file: File;
  permissions: UserRoles[];
}

export const useDocumentPermissions = () => {
  const [documents, setDocuments] = useState<DocumentWithPermission[]>([]);

  const addDocuments = (files: File[]) => {
    const newDocs = files.map((file) => ({
      id: `${file.name}-${Date.now()}-${Math.random()}`,
      file,
      // Default to standard access roles, but UI provides options
      permissions: [],
    }));
    setDocuments((prev) => [...prev, ...newDocs]);
  };

  const removeDocument = (id: string) => {
    setDocuments((prev) => prev.filter((doc) => doc.id !== id));
  };

  const updatePermissions = (id: string, permissions: UserRoles[]) => {
    setDocuments((prev) =>
      prev.map((doc) => (doc.id === id ? { ...doc, permissions } : doc)),
    );
  };

  const clearDocuments = () => {
    setDocuments([]);
  };

  const removeDocumentsByFilenames = (filenames: string[]) => {
    if (filenames.length === 0) {
      return;
    }

    const remainingNames = new Set(filenames);
    setDocuments((prev) =>
      prev.filter((doc) => {
        if (!remainingNames.has(doc.file.name)) {
          return true;
        }
        remainingNames.delete(doc.file.name);
        return false;
      }),
    );
  };

  return {
    documents,
    addDocuments,
    removeDocument,
    updatePermissions,
    clearDocuments,
    removeDocumentsByFilenames,
  };
};
